// todo: move this to sandbox main.js file
import auth_sandbox from '../templates/auth_sandbox'
import sandbox from '../templates/sandbox'
import audio from '../templates/audio'

// todo: move this to style_guide main.js file
import style_guide_main from '../templates/style_guide/main'
import fonts from '../templates/style_guide/fonts'
import atoms from '../templates/style_guide/atoms'
import molecules from '../templates/style_guide/molecules'
import organisms from '../templates/style_guide/organisms'

import main from '../templates/main'

export default {
  main,
  auth_sandbox,
  sandbox,
  audio,
  style_guide: {
    main: style_guide_main,
    fonts,
    atoms,
    molecules,
    organisms
  }
}


// WEBPACK FOOTER //
// ./src/router/components.js